import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=d605e35a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d605e35a')) {
      api.createRecord('d605e35a', component.options)
    } else {
      api.reload('d605e35a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=d605e35a&", function () {
      api.rerender('d605e35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21E7LEyCdgPhK/JS/pricehelp.vue"
export default component.exports